const IS_DEVELOPMENT: boolean =
	!process.env.NODE_ENV || process.env.NODE_ENV === 'development';
const IS_PRODUCTION = !IS_DEVELOPMENT;

const FORCE_DEBUG = false;
const IS_DEBUG = IS_DEVELOPMENT || FORCE_DEBUG;

export { IS_DEBUG, IS_DEVELOPMENT, IS_PRODUCTION };
